<article class="dashboard responsive-8-4">
	<stages-page-header
		[headline]="(pageHeader$ | async)!"
		[breadCrumbTemplate]="(breadCrumb$ | async)!"
		[backButtonDisabled]="(backButtonDisabled$ | async)!"
		[showProcessVersionSwitch]="(showProcessVersionSwitch$ | async)!"
		(backButtonClicked)="onDetailsClosed()"
	></stages-page-header>
	<div class="container row">
		<div class="container column" [ngClass]="(showSecondCard$ | async)! ? 'col-8' : 'col-12'">
			<stages-tab-card [showTabs]="!(showSecondCard$ | async)!" [tabs]="tabs"> </stages-tab-card>
		</div>
		<ng-container *ngIf="showSecondCard$ | async as showSecondCard">
			<div class="container column col-4">
				<stages-card [showHeader]="showSecondCard">
					<ng-container *ngTemplateOutlet="interfacesFilter"></ng-container>
					<div class="footer"></div>
				</stages-card>
			</div>
		</ng-container>
	</div>
</article>

<ng-template #interfacesFilter>
	<stages-process-interfaces-filter
		[dropdownContent]="(dropdownContent$ | async)!"
		[showSearch]="(showSecondCard$ | async)!"
	>
	</stages-process-interfaces-filter>
</ng-template>
